<template lang="">
  <div id="header">
    <div class="inner_header">
      <h1 id="logo"><a @click="toHome"><span>Blossom</span>Logos</a></h1>
      <div id="gnb_pc">
        <nav>
          <ul class="depth_01">
            <li v-for="(menu, index) in menus" :key="index" @mouseover="showSubmenu(index)" @mouseleave="hideSubmenu(index)">
              <a @click="toMenu(menu.page)">{{ menu.name }}</a>
              <!-- <ul class="depth_02" v-show="menu.isHovered">
                <li v-for="(submenu, subIndex) in menu.submenus" :key="subIndex">
                  <a href="">{{ submenu }}</a>
                </li>
              </ul> -->
            </li>
          </ul>
        </nav>
      </div>
      <div id="gnb_mo" :class="{'open' : moNavShow }">
        <div class="mobile_header">
            <h1 id="logo"><a href=""><span>Blossom</span> Logos</a></h1>
            <a href="" class="gnb_mo_close"></a>
        </div>
        <div class="mobile_body">
            <p style="display:none;">
                고객님께서는 현재 '로그아웃' 상태입니다. <br>
                로그인 하시면 더욱 많은 정보와 혜택이 기다리고 있습니다.
            </p>
            <div class="btn_wrap">
                <a class="go_login" @click="toLogin">LOGIN</a>
                <a class="go_join" @click="toCs">CS Center</a>
            </div>
        </div>
        <nav>
          <ul class="depth_01">
            <li v-for="(menu, index) in menus" :key="index" @mouseover="showSubmenu(index)" @mouseleave="hideSubmenu(index)">
              <a @click="toMenu(menu.page)">{{ menu.name }}</a>
              <!-- <ul class="depth_02" v-show="menu.isHovered">
                <li v-for="(submenu, subIndex) in menu.submenus" :key="subIndex">
                  <a href="">{{ submenu }}</a>
                </li>
              </ul> -->
            </li>
          </ul>
        </nav>
        <div class="call_service">
            <div class="img_wrap">
                <img src="@/assets/images/common/ico_cs.png" alt="고객센터 이용안내">
            </div>
            <div class="txt_wrap">
                <p>고객센터 이용안내</p>
                <h5>070-4233-0655</h5>
                <span>통화량이 많을 때는 1:1 문의를 이용해주세요.</span>
            </div>
        </div>
    </div>
      <div class="btn_box">
        <a class="btn_login"><img src="@/assets/images/common/ico_login.svg" alt="로그인" @click="toLogin"></a>
        <a class="btn_sitemap"><img src="@/assets/images/common/ico_menu.svg" alt="사이트맵" @click="moNav"></a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';


const accountModule = 'accountModule'

export default {
  data() {
    return {
      menus: [
        {
          name: "디지털기부화환",
          submenus: ["서브메뉴1", "서브메뉴2", "서브메뉴3"],
          page: 'OverviewPage',
          isHovered: false,
        },
        {
          name: "청첩장",
          submenus: ["서브메뉴1", "서브메뉴2", "서브메뉴3"],
          page: 'WeddingInvitationPage',
          isHovered: false,
        },
        {
          name: "부고장",
          submenus: ["서브메뉴1", "서브메뉴2", "서브메뉴3"],
          page: 'FuneralInvitationPage',
          isHovered: false,
        },
        {
          name: "기부후원단체",
          submenus: ["서브메뉴1", "서브메뉴2", "서브메뉴3"],
          page: 'DonationGroupListPage',
          isHovered: false,
        },
        {
          name: "후원캠페인",
          submenus: ["서브메뉴1", "서브메뉴2", "서브메뉴3"],
          page: 'CampaignListPage',
          isHovered: false,
        },        
        {
          name: "후원활동",
          submenus: ["서브메뉴1", "서브메뉴2", "서브메뉴3"],
          page: 'SponsorListPage',
          isHovered: false,
        },
      ],

      moNavShow : false ,
    };
  },
  methods: {
    ...mapActions(accountModule, [
      'requestCheckLogin',
    ]),

    toHome () {
      this.$router.push({ name: 'home' })
    },

    async toLogin () {
      // if (await this.requestCheckLogin()) {
        this.$router.push({ name: 'MyPage' });
        this.moNavShow = false;
      // } else {
      //   this.$router.push({ name: 'AccountLoginPage' })
      // }
    },

    moNav () {
      this.moNavShow = true;
    },

    toCs () {
      this.$router.push({ name: 'NoticeListPage' })
      this.moNavShow = false;
    },

    showSubmenu(index) {
      this.menus[index].isHovered = true;
    },

    hideSubmenu(index) {
      this.menus[index].isHovered = false;
    },

    toMenu(menuPage) {
      if (menuPage === '') alert('개발중입니다')
      else {
        this.$router.push({ name: menuPage });
        this.moNavShow = false;
      }
    }
  }
}
</script>
<style lang="">

</style>